<template>
  <div>
    <Sidebar />
    <div class="content">
      <NavBar />
      <main>
        <div class="header">
          <div class="left">
            <h1>Projetos Arquivados - Solar</h1>
          </div>
          <button class="btn btn-primary btn-all mr-3" @click="generatePdf">
            <i class='bx bx-download'></i>
            Gerar PDF
          </button>
        </div>

        <!-- Botões de Filtro -->
        <div v-show="role == 2" class="filtros-topo" style="display: flex; gap: 10px; margin-bottom: 20px;">
          <button class="btn btn-primary btn-all mr-3" @click="showFilterModal = true">
            <i class="bx bx-filter"></i>
          </button>

          <button class="btn btn-primary btn-all mr-3" @click="sortByDate">Data de criação</button>
          <button class="btn btn-primary btn-all mr-3" @click="sortByStatus">Situação</button>
          <button class="btn btn-secondary" @click="clearFilters">Limpar</button>
        </div>

        <!-- Modal de Filtro -->
        <div v-if="showFilterModal" class="modal-backdrop">
          <div class="modal-content">
            <h3>Filtros</h3>

            <div class="row">
              <div class="col-12 col-sm-6">
                <div class="form-input mb-3">
                  <label>Data de Início</label>
                  <input type="date" v-model="filters.startDate" class="form-control" />
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="form-input mb-3">
                  <label>Data de Fim</label>
                  <input type="date" v-model="filters.endDate" class="form-control" />
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="form-input mb-3">
                  <label>Pagamento</label>
                  <select v-model="filters.paymentType" class="form-control" >
                    <option value="">Todos</option>
                    <option v-for="(label, key) in paymentOptions" :key="key" :value="key">
                      {{ label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="modal-actions">
              <button @click="showFilterModal = false" class="btn btn-danger">Cancelar</button>
              <button @click="applyFilters" class="btn btn-success">Filtrar</button>
            </div>
          </div>
        </div>

        <!-- Listagem de Projetos Arquivados -->
        <div class="bottom-data">
          <div class="orders">
            <div class="header">
              <i class="bx bx-message-square-dots"></i>
              <h3>Listagem de Arquivados</h3>
            </div>
            <div v-if="projects.length === 0" class="empty-state">
              <p>Nenhum projeto arquivado encontrado.</p>
            </div>
            <template v-else>
              <table v-if="role != 2">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nome</th>
                  <th>Criação</th>
                  <th>Pagamento</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="project in projects" :key="project.id">
                  <td>{{ project.id }}</td>
                  <td>{{ project.project_name }}</td>
                  <td>{{ formatDate(0, project.created_at) }} </td>
                  <td>
                    <span class="status" :class="statusPay(project.payment_status)">
                      {{ getStatusPay(project.payment_status) }}
                    </span>
                  </td>
                  <td class="actions-icon">
                    <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                      <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                        class="bx bx-detail ml-5 mr-5 icon-primary">
                      </span>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-show="role == 2" v-for="(item, index) in filteredProjects" :key="index" class="accordion-item">
              <button @click="toggle(index)" class="accordion-header">
                {{ item.full_name }}
              </button>
              <div v-show="activeIndex === index" class="accordion-content">
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nome</th>
                      <th>ID Geração</th>
                      <th>Criação</th>
                      <th>Situação</th>
                      <th>Pagamento</th>
                      <th>Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="project in item.listProject" :key="project.id">
                      <td>{{ project.id }}</td>
                      <td>{{ project.project_name }}</td>
                      <td>{{ project.id_generation }}</td>
                      <td>{{ formatDate(0, project.created_at) }} </td>
                      <td>
                        <span class="status" :class="getStatusClass(project.id_state)">
                          {{ getStatusText(project.id_state) }}
                        </span>
                      </td>
                      <td>
                        <span class="status" :class="statusPay(project.payment_status)">
                          {{ getStatusPay(project.payment_status) }}
                        </span>
                      </td>
                      <td class="actions-icon">
                        <router-link :to="{ name: 'project-manager', params: { projeto: project.id } }">
                          <span data-bs-toggle="tooltip" tooltip-bs-title="Ver detalhes do projeto"
                            class="bx bx-detail ml-5 mr-5 icon-primary">
                          </span>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            </template>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoInoveng from "@/assets/images/logo_inoveng.png";
import NavBar from '@/components/NavBar.vue';
import Sidebar from '@/components/SideBar.vue';

export default {
  components: {
    NavBar,
    Sidebar,
  },
  data() {
    return {
      role: this.$store.state.role,
      showFilterModal: false,
      filters: {
        startDate: '',
        endDate: '',
        paymentType: ''
      },
      projects: [],
      filteredProjects: [],
      activeIndex: null,
      paymentOptions: {
        1: 'Aguardando Pagamento 1/2',
        2: 'Pagamento Confirmado 1/2',
        3: 'Aguardando pagamento RRT',
        4: 'Pagamento RRT Confirmado',
        5: 'Aguardando Pagamento 2/2',
        6: 'Pago'
      }
    };
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    clearFilters() {
      this.filters = {
        startDate: '',
        endDate: '',
        paymentType: ''
      };
      this.filteredProjects = this.projects;
    },
    applyFilters() {
      this.showFilterModal = false;
      const start = this.filters.startDate ? new Date(this.filters.startDate) : null;
      const end = this.filters.endDate ? new Date(this.filters.endDate + 'T23:59:59') : null;
      const payment = this.filters.paymentType ? [String(this.filters.paymentType)] : [];

      const result = this.projects.map(group => {
        const filteredList = group.listProject.filter(proj => {
          const createdAt = new Date(proj.created_at);
          const inRange = (!start || createdAt >= start) && (!end || createdAt <= end);
          const matchPay = !payment.length || payment.includes(String(proj.payment_status));
          return inRange && matchPay;
        });
        return Object.assign({}, group, { listProject: filteredList });
      }).filter(group => group.listProject.length > 0);

      this.filteredProjects = JSON.parse(JSON.stringify(result));

    },
    sortByDate() {
      this.filteredProjects = this.filteredProjects.map(group => {
        const sortedList = [...group.listProject].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        return { ...group, listProject: sortedList };
      });
    },
    sortByStatus() {
      this.filteredProjects = this.filteredProjects.map(group => {
        const sortedList = [...group.listProject].sort((a, b) => a.payment_status - b.payment_status);
        return { ...group, listProject: sortedList };
      });
    },
    formatDate(type, date) {
      if (!date) return '';
      const d = new Date(date);
      return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
    },
    statusPay(status) {
      switch (status) {
        case 1:
          return 'warning';
        case 2:
          return 'light-warning';
        case 3:
          return 'warning';
        case 4:
          return 'light-warning';
        case 5:
          return 'pending';
        case 6:
          return 'success';
      }
    },
    getStatusClass(status) {
      switch (status) {
        case 1:
          return 'dark-grey';
        case 2:
          return 'light-warning';
        case 3:
          return 'pending';
        case 4:
          return 'warning';
        case 5:
          return 'danger';
        case 6:
          return 'success';
        case 7:
        case 10:
          return 'primary';
        case 8:
          return 'completed';
        case 9:
          return 'cancelled';
      }
    },
    getStatusPay(status) {
      switch (status) {
        case 1:
          return 'Aguardando Pagamento 1/2';
        case 2:
          return 'Pagamento Confirmado 1/2';
        case 3:
          return 'Aguardando pagamento RRT';
        case 4:
          return 'Pagamento RRT Confirmado';
        case 5:
          return 'Aguardando Pagamento 2/2';
        case 6:
          return 'Pago';
      }
    },
    load() {
      return this.$http
        .get("user/projects/list/1?archived=true", {
          headers: {
            Authorization: "Bearer " + Cookie.get("_token"),
          },
        })
        .then((response) => {
          this.projects = response.data.projects;
          this.filteredProjects = this.projects;
        })
        .catch(() => {
          alert("Erro ao carregar projetos arquivados");
        });
    },
    buildRows(projects) {
      return projects.map((project) => ([
        project.id,
        project.project_name,
        this.formatDate(0, project.created_at),
        this.getStatusPay(project.payment_status)
      ]));
    },
    buildRowsWithGeneration(projects) {
      return projects.map((project) => ([
        project.id,
        project.project_name,
        project.id_generation,
        this.formatDate(0, project.created_at),
        this.getStatusPay(project.payment_status)
      ]));
    },
    addSectionTitle(doc, title, startY) {
      doc.setFontSize(12);
      doc.setTextColor(20);
      doc.text(title, 40, startY);
      return startY + 10;
    },
    loadLogoDataUrl() {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = () => resolve(null);
        img.src = logoInoveng;
      });
    },
    async generatePdf() {
      const data = this.role == 2 ? this.filteredProjects : this.projects;
      if (!data || data.length === 0) {
        await this.load();
      }
      const refreshed = this.role == 2 ? this.filteredProjects : this.projects;
      if (!refreshed || refreshed.length === 0) {
        alert("Nenhum projeto arquivado encontrado para gerar o relatório.");
        return;
      }

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'pt',
        format: 'a4'
      });

      const logoDataUrl = await this.loadLogoDataUrl();
      const now = new Date();
      const title = 'Relatório de Projetos Arquivados - Solar';
      const subtitle = `Gerado em ${this.formatDate(0, now)}`;
      const headerHeight = logoDataUrl ? 70 : 50;

      const drawHeader = () => {
        if (logoDataUrl) {
          doc.addImage(logoDataUrl, 'PNG', 40, 18, 90, 30);
        }
        doc.setFontSize(16);
        doc.setTextColor(20);
        doc.text(title, 140, 36);
        doc.setFontSize(10);
        doc.setTextColor(80);
        doc.text(subtitle, 140, 52);
      };

      drawHeader();
      let currentY = headerHeight + 10;

      if (this.role == 2) {
        const head = [[
          '#',
          'Nome',
          'ID Geracao',
          'Criacao',
          'Pagamento'
        ]];

        this.filteredProjects.forEach((group) => {
          currentY = this.addSectionTitle(doc, `Integrador: ${group.full_name}`, currentY);
          autoTable(doc, {
            head,
            body: this.buildRowsWithGeneration(group.listProject || []),
            startY: currentY,
            margin: { top: headerHeight },
            theme: 'grid',
            styles: { fontSize: 9, cellPadding: 6 },
            headStyles: { fillColor: [230, 120, 23] },
            rowPageBreak: 'avoid',
            didDrawPage: drawHeader
          });
          currentY = doc.lastAutoTable.finalY + 18;
        });
      } else {
        const head = [[
          '#',
          'Nome',
          'Criacao',
          'Pagamento'
        ]];

        autoTable(doc, {
          head,
          body: this.buildRows(this.projects),
          startY: currentY,
          margin: { top: headerHeight },
          theme: 'grid',
          styles: { fontSize: 9, cellPadding: 6 },
          headStyles: { fillColor: [230, 120, 23] },
          rowPageBreak: 'avoid',
          didDrawPage: drawHeader
        });
      }

      doc.save('relatorio-projetos-arquivados-solar.pdf');
    }
  },
  created() {
    this.load();
  },
};
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  width: 600px;
  max-width: 90%;
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.btn-roxo {
  background: #3c1053;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 30px;
  cursor: pointer;
}

.empty-state {
  padding: 40px;
  text-align: center;
  color: #999;
}
</style>
